import { APIPath } from 'utility/constant'
import { BaseService } from './base'

class TemplateUserServiceClass extends BaseService {
    async getByUserId(userId) {
        const response = await BaseService.get(`${APIPath.templateUserByUserId}${userId}`)
        return response
    }

    async create(data) {
        const response = await BaseService.post(APIPath.templateUser, data)
        return response
    }

    getById(id) {
        return BaseService.get(`${APIPath.templateUserById}${id}`)
    }

    getByTemplate(templateId) {
        return BaseService.get(`${APIPath.templateUserByTemplate}${templateId}`)
    }

    update(data) {
        return BaseService.post(APIPath.templateUserUpdate, data)
    }

    remove(id) {
        return BaseService.post(`${APIPath.templateUserDelete}${id}`)
    }

    // New APIs from Postman collection
    getList(companyId, templateId) {
        return BaseService.get(`${APIPath.templateUserList}/${companyId}/${templateId}`)
    }

    sync(data) {
        return BaseService.post(APIPath.templateUserSync, data)
    }
}

export const TemplateUserService = new TemplateUserServiceClass()